import { getCurrentInstance } from "vue";

export default function useStepEmits() {
  const instance = getCurrentInstance();
  const emitStepCompleted = (isStepComplete: boolean) => {
    instance?.emit("stepComplete", {
      isStepComplete,
      stepName: instance?.type.__name,
    });
  };
  const emitStepLoading = (isStepLoading: boolean) => {
    instance?.emit("stepLoading", {
      isStepLoading,
      stepName: instance?.type.__name,
    });
  };
  return { emitStepCompleted, emitStepLoading };
}
